import React from "react";
import Logo from "../../Image/Logo.jpg";
const LoadingPage = () => {
  return (
    <div className="loading-container">
      <div className="flex items-center justify-center flex-col">
        <img src={Logo} className=" size-80" alt="Loading Logo" />
        <p className="text-3xl text-center loading-text">Loading ....</p>
      </div>
    </div>
  );
};

export default LoadingPage;
